export const SERVER_DATE_FORMAT = 'yyyy-MM-dd';
